import './spinner.css';

export default function Spinner() {
    return (
    <div className="spinner">
        <span></span>
    </div>
    )
}